<!--
  Cleveland (idSite 615) tenant chrome — AAAND ACTION CTA + GCFC rich footer.
  Sits ABOVE the existing site-footer strip in app.html.
-->

<!-- ============ AAAND... ACTION! CTA banner ============ -->
<section class="gcfc-cta" aria-label="Support Greater Cleveland Film Commission">
  <div class="gcfc-cta-inner">
    <div class="gcfc-cta-copy">
      <h2 class="gcfc-cta-headline">AAAND... ACTION!</h2>
      <p class="gcfc-cta-body">
        WE ACTIVELY TRAIN LOCAL CREW AND PURSUE FEATURE FILMS, LAYING THE GROUNDWORK
        FOR MONTHS IF NOT YEARS IN ADVANCE OF FILMING, IN ORDER TO BRING NEW
        PRODUCTION INVESTMENT AND JOBS TO OUR REGION. BUT WE CAN'T DO IT
        ALONE&hellip;WE NEED YOU TO JOIN OUR MISSION!
      </p>
      <div class="gcfc-cta-actions">
        <a [href]="donateHref" target="_blank" rel="noopener" class="gcfc-cta-btn">MAKE A DONATION</a>
        <a [href]="membershipsHref" target="_blank" rel="noopener" class="gcfc-cta-btn">EXPLORE MEMBERSHIPS</a>
      </div>
    </div>
    <div class="gcfc-cta-photo" aria-hidden="true">
      <img src="assets/tenants/615/clapboard.jpg" alt="" />
    </div>
  </div>
</section>

<!-- ============ Dark 6-column rich footer ============ -->
<footer class="gcfc-footer" aria-label="Greater Cleveland Film Commission">
  <div class="gcfc-footer-strip gcfc-footer-strip-left"  aria-hidden="true"><span class="gcfc-filmstrip-label">SUPER 35MM 07</span></div>
  <div class="gcfc-footer-strip gcfc-footer-strip-right" aria-hidden="true"></div>

  <div class="gcfc-footer-inner">
    <!-- Row 1 -->
    <div class="gcfc-footer-row">
      <div class="gcfc-col gcfc-col-stay">
        <div class="gcfc-stay-card">
          <div class="gcfc-stay-text">
            <span class="gcfc-stay-headline">STAY<br/>CONNECTED</span>
            <a class="gcfc-stay-btn" [href]="newsletterHref" target="_blank" rel="noopener">SIGN UP FOR NEWS</a>
          </div>
          <div class="gcfc-stay-icon" aria-hidden="true">
            <svg xmlns="http://www.w3.org/2000/svg" width="92" height="78" viewBox="0 0 92 78" fill="none" stroke="#FF4434" stroke-width="3.5" stroke-linejoin="round" stroke-linecap="round">
              <path d="M8 18l30-10 46 14-14 50-46-12L8 18z"/>
              <line x1="22" y1="28" x2="62" y2="38"/>
              <line x1="20" y1="38" x2="60" y2="48"/>
              <line x1="18" y1="48" x2="58" y2="58"/>
            </svg>
          </div>
        </div>
      </div>

      <div class="gcfc-col">
        <h3 class="gcfc-col-head">FILM HERE</h3>
        <ul class="gcfc-col-links">
          <li *ngFor="let l of filmHere"><a [href]="l.href" target="_blank" rel="noopener">{{ l.label }}</a></li>
        </ul>
      </div>

      <div class="gcfc-col">
        <h3 class="gcfc-col-head">WORK HERE</h3>
        <ul class="gcfc-col-links">
          <li *ngFor="let l of workHere"><a [href]="l.href" target="_blank" rel="noopener">{{ l.label }}</a></li>
        </ul>
      </div>

      <div class="gcfc-col">
        <h3 class="gcfc-col-head">JOIN &amp; GIVE</h3>
        <ul class="gcfc-col-links">
          <li *ngFor="let l of joinGive"><a [href]="l.href" target="_blank" rel="noopener">{{ l.label }}</a></li>
        </ul>
      </div>
    </div>

    <!-- Row 2 -->
    <div class="gcfc-footer-row gcfc-footer-row-2">
      <div class="gcfc-col gcfc-col-contact">
        <h3 class="gcfc-col-head">ADDRESS</h3>
        <address class="gcfc-address">
          THE LEADER BUILDING<br/>
          526 SUPERIOR AVE<br/>
          SUITE 350<br/>
          CLEVELAND, OH 44114
        </address>

        <h3 class="gcfc-col-head gcfc-col-head-phone">PHONE</h3>
        <p class="gcfc-phone"><a href="tel:+12166233910">(216) 623-3910</a></p>

        <ul class="gcfc-socials">
          <li *ngFor="let s of socials">
            <a [href]="s.href" target="_blank" rel="noopener" [attr.aria-label]="s.label" [title]="s.label">
              <ng-container [ngSwitch]="s.label">
                <svg *ngSwitchCase="'Instagram'" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="2" width="20" height="20" rx="5"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/><circle cx="17.5" cy="6.5" r="1.2" fill="currentColor" stroke="none"/></svg>
                <svg *ngSwitchCase="'LinkedIn'" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="currentColor"><path d="M20.45 20.45h-3.55v-5.57c0-1.33-.02-3.04-1.86-3.04-1.86 0-2.15 1.45-2.15 2.95v5.66H9.34V9h3.41v1.56h.05c.48-.9 1.64-1.86 3.37-1.86 3.6 0 4.27 2.37 4.27 5.46v6.29zM5.34 7.43a2.06 2.06 0 1 1 0-4.13 2.06 2.06 0 0 1 0 4.13zM7.12 20.45H3.56V9h3.56v11.45z"/></svg>
                <svg *ngSwitchCase="'Facebook'" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="currentColor"><path d="M22 12a10 10 0 1 0-11.56 9.88v-6.99H7.9V12h2.54V9.8c0-2.51 1.49-3.89 3.77-3.89 1.09 0 2.24.2 2.24.2v2.46h-1.26c-1.24 0-1.63.77-1.63 1.56V12h2.78l-.45 2.89h-2.33v6.99A10 10 0 0 0 22 12z"/></svg>
                <svg *ngSwitchCase="'YouTube'" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="currentColor"><path d="M23.5 6.2a3 3 0 0 0-2.1-2.1C19.6 3.5 12 3.5 12 3.5s-7.6 0-9.4.6A3 3 0 0 0 .5 6.2 31 31 0 0 0 0 12a31 31 0 0 0 .5 5.8 3 3 0 0 0 2.1 2.1c1.8.6 9.4.6 9.4.6s7.6 0 9.4-.6a3 3 0 0 0 2.1-2.1A31 31 0 0 0 24 12a31 31 0 0 0-.5-5.8zM9.6 15.6V8.4l6.4 3.6-6.4 3.6z"/></svg>
                <svg *ngSwitchCase="'X'" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 3l8 10L3 21h2.5l6.7-7.3L17.5 21H21l-8.4-10.4L20.5 3H18l-6 6.6L8 3H3z" fill="currentColor" stroke="none"/></svg>
              </ng-container>
            </a>
          </li>
        </ul>
      </div>

      <div class="gcfc-col">
        <h3 class="gcfc-col-head">ABOUT</h3>
        <ul class="gcfc-col-links">
          <li *ngFor="let l of about"><a [href]="l.href" target="_blank" rel="noopener">{{ l.label }}</a></li>
        </ul>
      </div>

      <div class="gcfc-col">
        <h3 class="gcfc-col-head">OUR IMPACT</h3>
        <ul class="gcfc-col-links">
          <li *ngFor="let l of ourImpact"><a [href]="l.href" target="_blank" rel="noopener">{{ l.label }}</a></li>
        </ul>
      </div>

      <div class="gcfc-col">
        <h3 class="gcfc-col-head">CONTACT</h3>
        <ul class="gcfc-col-links">
          <li><a href="https://www.clevelandfilm.com/contact" target="_blank" rel="noopener">Contact</a></li>
          <li *ngFor="let l of contact"><a [href]="l.href" target="_blank" rel="noopener">{{ l.label }}</a></li>
        </ul>
      </div>
    </div>
  </div>
</footer>
